module.exports = __webpack_public_path__ + "static/media/pratilili_logo_720.6a7bd50a.png";